import { Controller } from "@hotwired/stimulus"

// Live-previews the chosen team crest image before the form is submitted.
export default class extends Controller {
  static targets = ["input", "image", "placeholder"]

  preview() {
    const file = this.inputTarget.files[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = (event) => {
      this.imageTarget.src = event.target.result
      this.imageTarget.classList.remove("hidden")
      if (this.hasPlaceholderTarget) this.placeholderTarget.classList.add("hidden")
    }
    reader.readAsDataURL(file)
  }
}
